export default "__VITE_ASSET__BDUtqpi8__"